import React, { useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import { getAPIBaseURL } from "../../services/helpers"
import { getData } from "../../services/request"

const statuses = ['ALL', 'PENDING', 'PRICED', 'PAID', 'PAYMENT_CONFIRMED', 'DELIVERED', 'RECEIVED', 'CANCELLED']

const AdminRequests = () => {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const [statusFilter, setStatusFilter] = useState('ALL')
  const [query, setQuery] = useState("")

  const fetchItems = async () => {
    setLoading(true)
    setError("")
    const url = `${getAPIBaseURL()}/v1/posts`
    const params = { limit: 200, skip: 0 }
    if(statusFilter !== 'ALL') params.status = statusFilter
    const res = await getData(url, {}, params)
    setLoading(false)
    if(res.error == ""){
      if(res.result.status === 200){
        setItems(res.result.data?.data || [])
      }else{
        setItems([])
        setError(res.result.data?.message || 'No requests found')
      }
    }else{
      setError(res.result?.data?.message || 'Network error')
    }
  }

  useEffect(()=>{ fetchItems() }, [statusFilter])

  const filtered = useMemo(()=>{
    const q = query.trim().toLowerCase()
    if(!q) return items
    return items.filter(req => (
      (req.message || '').toLowerCase().includes(q) ||
      (req.userId?.name || '').toLowerCase().includes(q) ||
      (req.userId?.email || '').toLowerCase().includes(q)
    ))
  }, [items, query])

  const formatDate = (iso) => {
    try { return new Date(iso).toLocaleString() } catch { return iso }
  }

  return (
    <section className="mx-auto max-w-6xl">
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Requests</h1>
          <p className="text-sm text-gray-600">View and moderate all patient requests</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <select value={statusFilter} onChange={(e)=>setStatusFilter(e.target.value)} className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-black focus:outline-none focus:ring-2 focus:ring-black">
            {statuses.map((status) => (
              <option key={status} value={status}>{status}</option>
            ))}
          </select>
          <input value={query} onChange={(e)=>setQuery(e.target.value)} placeholder="Search requests" className="w-64 max-w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-black focus:outline-none focus:ring-2 focus:ring-black" />
        </div>
      </div>

      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
        {loading ? (
          <div className="p-6 text-sm text-gray-500">Loading...</div>
        ) : error ? (
          <div className="p-6 text-sm text-red-600">{error}</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 text-left text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 font-semibold text-gray-700">Request</th>
                  <th className="px-4 py-3 font-semibold text-gray-700">Patient</th>
                  <th className="px-4 py-3 font-semibold text-gray-700">Status</th>
                  <th className="px-4 py-3 font-semibold text-gray-700">Created</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {filtered.map((req) => (
                  <tr key={req._id} className="hover:bg-gray-50">
                    <td className="px-4 py-3">
                      <div className="font-medium text-gray-900 line-clamp-2">{req.message}</div>
                    </td>
                    <td className="px-4 py-3 text-gray-700">
                      <div className="font-medium">{req.userId?.name || req.userId?.organization || 'Unknown'}</div>
                      <div className="text-xs text-gray-500">{req.userId?.email}</div>
                    </td>
                    <td className="px-4 py-3">
                      <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${req.status === 'CANCELLED' ? 'bg-red-100 text-red-700' : 'bg-blue-100 text-blue-700'}`}>
                        {req.status}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">{formatDate(req.createdAt)}</td>
                    <td className="px-4 py-3 text-right">
                      <Link to={`/admin/app/requests/${req._id}`} className="rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50">Open</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filtered.length === 0 ? (
              <div className="p-6 text-sm text-gray-500">No matching requests</div>
            ) : null}
          </div>
        )}
      </div>
    </section>
  )
}

export default AdminRequests


